class AbstractManager {
  __base;
  get __element() {
    return this.__base.$el;
  }
  get __config() {
    return this.__base.__config;
  }
  get __eventsManager() {
    return this.__base.__events;
  }
  constructor(base) {
    this.__base = base;
    this.__hideProperties(["__base"]);
  }
  __hideProperties(properties) {
    Object.defineProperties(
      this,
      Object.fromEntries(
        properties.map((property) => [
          property,
          {
            enumerable: false,
            writable: false,
            value: this[property]
          }
        ])
      )
    );
  }
}
export {
  AbstractManager
};
//# sourceMappingURL=AbstractManager.js.map
